import { AddFeedbackRequest, GetSignedUrlRequest } from '@/types/GlobalType';
import { rtkApi } from '../rtkApi';

export interface InterestRateData {
  data: {
    rates: {
      conventional: number;
      fha: number;
      va: number;
      usda: number;
      dscr: number;
      commercial: number;
      fixAndFlip: number;
      bridge: number;
    };
    marketStress: {
      stressLevel: 'low' | 'medium' | 'high';
      factors: string[];
    };
    predictions: {
      conventional: number;
      fha: number;
      va: number;
      usda: number;
      dscr: number;
      commercial: number;
      fixAndFlip: number;
    };
  };
}

export const globalApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getInterestRate: builder.query<number, void>({
      query: () => ({ url: `/global/interest-rate` }),
    }),
    getLatestInterestRates: builder.query<InterestRateData, void>({
      query: () => ({ url: `/global/interest-rates/latest` }),
      providesTags: ['InterestRates'],
    }),
    getSignedUrl: builder.mutation<string, GetSignedUrlRequest>({
      query: (payload) => ({
        url: `/global/storage/signed-url`,
        params: payload,
      }),
    }),
    addFeedback: builder.mutation<void, AddFeedbackRequest>({
      query: (payload) => ({
        url: `/global/feedback`,
        method: 'POST',
        data: payload,
      }),
    }),
  }),
});

export const {
  useGetInterestRateQuery,
  useGetLatestInterestRatesQuery,
  useGetSignedUrlMutation,
  useAddFeedbackMutation,
} = globalApi;
